module.exports = __webpack_public_path__ + "img/客户logo_3.9b142223.png";